import React from "react";
import { useTranslation } from "react-i18next";
import Accordion from "~/components/utils/Accordion";
import AICharacterSettings from "~/components/AICharacterSettings";
import { VRM } from "@pixiv/three-vrm";
import { useVoiceSettings } from "../hooks/useVoiceSettings";

interface AISectionProps {
  loadedVrm: VRM | null;
  loadedVrmList: VRM[]; // オプションでVRMリストを受け取る
  handleCharacterSelect: (vrm: VRM) => void;
}

/**
 * AIキャラクター選択画面
 */
const AISection: React.FC<AISectionProps> = ({
  loadedVrm,
  handleCharacterSelect,
  loadedVrmList,
}) => {
  const { t } = useTranslation();
  const { isVoiceReady } = useVoiceSettings(loadedVrm);

  return (
    <Accordion
      items={[
        {
          title: t("aiSettings") + (isVoiceReady ? "" : `(${t("loading")})`),
          content: (
            <AICharacterSettings
              loadedVrm={loadedVrm}
              loadedVrmList={loadedVrmList}
              handleCharacterSelect={handleCharacterSelect}
              isVoiceReady={isVoiceReady}
            />
          ),
          dynamicHeight: true,
        },
      ]}
    />
  );
};

export default AISection;
